<template>
  <div class="s-question">
    <div class="journey-p2--container">
      <h3 class="text-light text-center">Since you will be written as part of our history, we would like to know a little bit more about our Orbiters.</h3>
      <div class="d-flex justify-content-center">
        <button class="btn btn-primary mt-5" type="button" @click="nextChapter">
        Continue <i class="el-icon-right"></i>
      </button>
      </div>
    </div>
    <el-button icon="el-icon-back" circle 
    class="back-btn"
    @click="previousQuestion"
    size="small"
    :class="[hideBack === true ? 'invisible': '']"></el-button>
    <div class="question--container container">
      <div class="w-75">
        <div class="question" v-for="(ask, i) in questions" :key="`ask-${ask.number}${i}`" 
        :class="[activeQuestion == i ? 'active' : 'd-none']">
          <div>
            <h2 class="text-light">{{ask.question}}</h2>
            <h4 class="text-muted mb-5 mt-3 font-weight-bold"> {{ ask.subdesc }} </h4>
            <textarea
              type="text"
              style="height:100px;"
              :name="`Number ${ask.number}`"
              v-model="ask.answer"
              class="answer--field w-100"
              placeholder="your answer here"
            ></textarea>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn btn-primary mt-5" type="button" @click="nextQuestion"
          :class="[percentage === 100 ? 'd-none': '']">Next Question</button>
          <button class="btn btn-primary mt-5" type="button" @click="submitAnswer"
          :class="[percentage !== 100 ? 'd-none': '']">Finish! <i class="el-icon-check"></i></button>
        </div>
        <div class="d-flex justify-content-center">
          <div class="progress-container">
            <el-tooltip class="item" effect="dark" :content="`${percentage}%`" placement="top-start">
              <el-progress :percentage="percentage" :color="customColor" :show-text="false"></el-progress>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <preview-dialog
    :dialogVisible="dialogVisible"
    @closeDialog="dialogVisible = false"/>

  </div>
</template>

<script>
import PreviewDialog from '../components/SignUpPreview.vue';
import { TimelineMax, Expo } from "gsap";
const timeline = new TimelineMax();

export default {
  components: {
    PreviewDialog,
  },
  data() {
    return {
      dialogVisible: false,
      questions: [
        {
          number: 1,
          question: "What are your motivations to join Orbit Pathfinder?",
          subdesc: '',
          answer: ""
        },
        {
          number: 2,
          question: "What is the biggest achievement you have ever achieved?",
          subdesc: `This is your chance to wow us. Don't be shy`,
          answer: ""
        },
        {
          number: 3,
          question: "Tell us, what are your strengths that you would like to improve?",
          subdesc: '',
          answer: ""
        },
        {
          number: 4,
          question: 'From your perspective, what is your weakness that you would like to change?',
          subdesc: '',
          answer: '',
        },
      ],
      customColor: "#f35a3b",
      percentage: 25,
      activeQuestion: 0,
      disabled: false,
      hideBack: true,
    };
  },
  methods: {
    nextChapter() {
      timeline.to('.journey-p2--container', 0.5, {
        opacity: 0,
        display: 'none',
      })
      .to('.question--container', 0.5, {
        opacity: 1,
        display: 'flex',
        ease: Expo.easeIn,
      });
    },
    nextQuestion() {

      const counts = this.questions.length;
      this.percentage += (100 / counts);
      this.hideBack = false;

      let active = this.activeQuestion + 1;
      if (active > counts) {
        active = 0;
      }

      this.activateImage(active);

      if (this.percentage > 100) {
        this.percentage = 100;
        this.disabled = true;
      }
    },
    activateImage(i) {
      this.activeQuestion = i;
    },
    previousQuestion() {
      this.percentage -= (100 / this.questions.length);
      this.disabled = false;
        if (this.percentage <= 25) {
          this.percentage = 25;
          this.hideBack = true;
        }
      let active = this.activeQuestion - 1;
      if (active < 1) {
        active = 0;
      }
      this.activateImage(active);
    },
    submitAnswer() {
      const empty = this.questions.find((v) => v.answer === '');
      if (empty) {
          this.$notify.error({
            title: 'Error',
            message: `There is still a question haven't answered yet!`,
          });
        } else {
          const data = this.questions.map(k => ({
            question: k.question,
            answer: k.answer,
          }));
          this.$store.dispatch("addToAnswer", data);
          this.dialogVisible = true;
        }
    }
  },
  computed: {
    getAnswer() {
      return this.$store.getters.getAnswerData;
    },
    questionLength() {
      return Number(100 /this.questions.length);
    }
  },
  mounted() {
    timeline.to('.journey-p2--container', 1, {
      opacity: 1,
      ease: Expo.easeIn,
    }, '+= 0.2');
  },
};
</script>

<style>
</style>